import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductReviewsComponent } from '@spartacus/storefront';

@Component({
  selector: 'cx-product-reviews',
  templateUrl: './product-reviews.component.html',
  styleUrl: './product-reviews.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomProductReviewsComponent extends ProductReviewsComponent {}
